var Model   = require("Model"),
    $       = require("jquery"),
    ol      = require("openlayers"),
    _       = require("underscore");
var OLVectorLayerStyle = Model.extend({

    initialize: function(mapnikStyleXML, zIndex, markerImgUrl){

        var that = this;
        that.zIndex = zIndex;
        that.markerImgUrl = markerImgUrl;
        that.styles = [];
        that._parseStyle(mapnikStyleXML);
    },

    _scaleDenominatorToZoomLevel: function (inputDenominator) {
        var scaleDenominators = [
            279541132.014, //1
            139770566.007, //2
            69885283.0036, //3
            34942641.5018, //4
            17471320.7509, //5
            8735660.37545, //6
            4367830.18772, //7
            2183915.09386, //8
            1091957.54693, //9
            545978.773466, //10
            272989.386733, //11
            136494.693366, //12
            68247.3466832, //13
            34123.6733416, //14
            17061.8366708, //15
            8530.9183354,  //16
            4265.4591677,  //17
            2132.72958385,  //18
            1066.364791925,  //19
            533.1823959625,  //20
            266.59119798125,  //21
            133.295598990625,  //22
            66.6477994953125,  //23
            33.32389974765625,  //24
            16.661949873828124,  //25
            8.330974936914062,  //26
            4.165487468457031,  //27
            2.0827437342285156,  //28
            1.0413718671142578,  //29
            0.5206859335571289  //30
        ];
        // Zoom level is 18 if smaller than 2132.729...
        var zoomLevel         = 30;

        scaleDenominators.forEach(function (denominator, index) {
            if (inputDenominator >= scaleDenominators[0])
                zoomLevel = 0;
            else if (inputDenominator > denominator &&
                inputDenominator <= scaleDenominators[index - 1])
            //TODO make test for authencity
                zoomLevel = index + 1;
        });

        //zoomLevel-=2;//???
        if(zoomLevel <=0){
            zoomLevel = 0;
        }

        if(zoomLevel >= 20){
            zoomLevel = 20;
        }


        return zoomLevel;
    },

    _preprocessMapnikFilter: function (filter) {
        var _filter;
        _filter = filter.replace(/(\]\s*)(&lt;=|&gt;=|\!=|=|&gt;|&lt;)(\s*)([^='\s\[\]()]+)/g, '$1$2$3\'$4\'');
        return _filter;
    },

    _postProcessJSFilter: function (filter) {
        var _filter;
        _filter = filter.replace(/(<=|>=|\!=|==|>|<)(\s*)\'null\'/g, '$1$2null');
        return _filter;
    },

    _parseStyle: function(xmlMapnikStyle){
        var that = this;
        var ruleParsers = OLVectorLayerStyle.SymbolizerParsers;
        var style = {
            rules     : [],
            filterMode: 'all', // Если first, значит берём первый подходящий стиль для объекта и останавливаемся.
            name      : '',
            opacity   : 1 // TODO: Мапник может отдать стиль с прозрачностью. Нужно обработать этот параметр.
        };

        var rule = {
            maxScale: null,
            minScale: null,
            filter  : null,

            symbolizers: {
                LINE          : null,
                LINEPATTERN   : null,
                POLYGON       : null,
                POLYGONPATTERN: null,
                POINT         : null,
                TEXT          : null,
                RASTER        : null,
                SHIELD        : null,
                BUILDING      : null,
                MARKERS       : null,
                GLYPH         : null
            }
        };

        var styles = $(xmlMapnikStyle.replace(/<Style/g, '<s').replace(/<\/Style/g, '</s').replace(/<!\[CDATA\[/g, '')).filter('s');

        styles.each(function(){
            var $this = $(this),
                s = null,
                rules = $this.find('rule'),
                filterMode = $this.attr('filter-mode'),
                name = $this.attr('name');

            if(!rules.length) return;

            s = $.extend(true, {}, style);

            s.filterMode = (filterMode == 'first')
                ? 'first'
                : 'all';

            s.name = name;

            rules.each(function(){
                var r = $.extend(true, {}, rule);

                $(this).children().each(function(){

                    var props;
                    var tag = this.tagName.replace('SYMBOLIZER', '');

                    // TODO: Нужно ещё распарсить AlsoFilter и ElseFilter

                    if(!(tag in ruleParsers)) return;

                    switch(tag){
                        case 'MINSCALEDENOMINATOR':
                            r['minScale'] = parseInt(this.innerHTML);
                            break;
                        case 'MAXSCALEDENOMINATOR':
                            r['maxScale'] = parseInt(this.innerHTML);
                            break;
                        case 'FILTER':
                            r['filter'] = that._postProcessJSFilter(ruleParsers[tag](that._preprocessMapnikFilter(this.innerHTML)));
                            break;
                        default:
                            props = that._getSymbolizePoperties(this);
                            if(props){
                                r.symbolizers[tag] = ruleParsers[tag](props, {'markerImgUrl': that.markerImgUrl});
                            }
                            break;
                    }
                });

                s.rules.push(r);
            });

            that.styles.push(s);
        });

        that.styles = that.styles.reverse();
    },

    getStyle: function(feature, curZoom, layerSort, invertPriority){
        var that = this,
            matchedRules = [],
            i, ii, rule, s,
            matchedStyles = [];

        for(i in that.styles){
            for(ii in that.styles[i].rules){
                rule = that.styles[i].rules[ii];
                // Тестим на min scale
                if(rule.minScale != null && curZoom >= that._scaleDenominatorToZoomLevel(parseInt(rule.minScale))) continue;
                // Тестим на max scale
                if(rule.maxScale != null && curZoom < that._scaleDenominatorToZoomLevel(parseInt(rule.maxScale))) continue;
                // Тестим на фильтр
                if(!that.matchFilter(feature, rule.filter)) continue;
                s = $.extend(true, {}, rule.symbolizers);
                if(s['TEXT'] !== null && s['TEXT']['cdata'] !== null){
                    s['TEXT']['cdata'] = (feature.get(s['TEXT']['cdata']) !== undefined)
                        ? feature.get(s['TEXT']['cdata'])
                        : '';
                }
                matchedRules.push(s);
                if(that.styles[i].filterMode == 'first') break;
            }
        }
        matchedRules.forEach(function (rule) {
            _.keys(OLVectorLayerStyle.SymbolizerParsers).forEach(function (symbol) {
                if (rule[symbol] === null) {
                    return;
                }
                // инвертированная сортировка слоя: выше в дереве OMS, больше значение, ибо нужен ZIndex (больше = выше)
                var baseZIndex = layerSort && layerSort[feature.get('layer')] ? layerSort[feature.get('layer')] : 0;
                // но так как необходимо работать с большими величинами смещения
                baseZIndex *= OLVectorLayerStyle.baseZIndexMultiplier;
                // для точечных объектов (их текстов и иконок) - особая магия
                // #7826 - требование, чтобы нижние объекты (по Y координате) перекрывали те, что выше, в пределах слоя
                // А чтобы точки не начали выбиваться относительно остальных слоев
                // (они при прочих равных и так выше остальных типов геометрии)
                // остальные слои сделаем чуточку ниже, чем максимтальный Y
                var pointZIndexDecrement = 21 * 1000 * 1000;

                // TODO для MVT на данный момент используется упрощенный формат фич, у его геометрии нет getCoordinates
                if (~feature.getGeometry().getType().indexOf('Point') && feature.getGeometry().getCoordinates) {
                    pointZIndexDecrement = feature.getGeometry().getCoordinates()[1];
                    // Т.к. Y - инвертированный, то вычитание меньшего Y дасть больший ZIndex
                    // однако mvt рисует точки в обратном порядке -_- (потому что они вне основного приоритета отрисовки),
                    // надо инвертировать "декремент"
                    if (invertPriority) {
                        pointZIndexDecrement *= -1;
                    }
                }
                baseZIndex -= pointZIndexDecrement;

                switch (symbol) {
                    case 'TEXT':
                        matchedStyles.push(new ol.style.Style({
                            text: new ol.style.Text({
                                font: 'bold'
                                + ' ' + rule[symbol]['size'] + 'px '
                                + rule[symbol]['face-name'],
                                offsetY: rule[symbol]['dy'],
                                offsetX: rule[symbol]['dx'],
                                fill: ol.style.Fill({
                                    color: rule[symbol]['fill']
                                }),
                                stroke: (rule[symbol]['halo-radius']
                                    ? new ol.style.Stroke({
                                    color: rule[symbol]['halo-fill'],
                                    width: rule[symbol]['halo-radius']
                                })
                                    : undefined),
                                text: '' + rule[symbol]['cdata'],
                                textBaseline: rule[symbol]['base-line'],
                                textAlign: rule[symbol]['text-align'],
                                overlap: rule[symbol]['allow-overlap']
                            }),
                            // тексты должны быть выше остального и иметь обратный ZIndex,
                            // чтобы в общем они рисовались позже остальных объектов
                            // но тексты более приоритетных слоев должны отрисоваться раньше,
                            // чтобы вытеснить при необходимости менее приоритетные тексты
                            zIndex: 1000 * OLVectorLayerStyle.baseZIndexMultiplier - baseZIndex
                        }));
                        break;

                    case 'POINT':
                        if (rule[symbol]['file'] !== null) {
                            matchedStyles.push(new ol.style.Style({
                                image: new ol.style.Icon({
                                    src: rule[symbol]['file'],
                                    scale: rule[symbol]['scale'],
                                    opacity: rule[symbol]['opacity'],
                                    rotation: rule[symbol]['rotation'],
                                    crossOrigin: 'anonymous'
                                }),
                                zIndex: baseZIndex
                            }));
                        } else {
                            matchedStyles.push(new ol.style.Style({
                                image: new ol.style.Circle({
                                    radius: rule[symbol]['radius'] * rule[symbol]['scale'],
                                    fill: new ol.style.Fill({
                                        color: rule[symbol]['fill-color']
                                    }),
                                    stroke: new ol.style.Stroke({
                                        color: rule[symbol]['stroke-color'],
                                        width: rule[symbol]['stroke-width'] * rule[symbol]['scale']
                                    }),
                                    rotation: rule[symbol]['rotation']
                                }),
                                zIndex: baseZIndex
                            }));
                        }
                        break;
                    case 'MARKERS':
                        if (rule[symbol]['file'] !== null) {
                            matchedStyles.push(new ol.style.Style({
                                image: new ol.style.Icon({
                                    src: rule[symbol]['file'],
                                    scale: rule[symbol]['scale'],
                                    opacity: rule[symbol]['opacity'],
                                    rotation: rule[symbol]['rotation'],
                                    crossOrigin: 'anonymous'
                                }),
                                zIndex: baseZIndex
                            }));
                        } else {
                            matchedStyles.push(new ol.style.Style({
                                image: new ol.style.Circle({
                                    radius: rule[symbol]['radius'] * rule[symbol]['scale'],
                                    fill: new ol.style.Fill({
                                        color: rule[symbol]['fill-color']
                                    }),
                                    stroke: new ol.style.Stroke({
                                        color: rule[symbol]['stroke-color'],
                                        width: rule[symbol]['stroke-width'] * rule[symbol]['scale']
                                    }),
                                    rotation: rule[symbol]['rotation']
                                }),
                                zIndex: baseZIndex
                            }));
                        }
                        break;

                    case 'POLYGON':
                        matchedStyles.push(new ol.style.Style({
                            fill: new ol.style.Fill({
                                color: rule[symbol]['fill-color']
                            }),
                            zIndex: baseZIndex
                        }));
                        break;

                    case 'LINE':
                        matchedStyles.push(new ol.style.Style({
                            stroke: new ol.style.Stroke({
                                color: rule[symbol]['stroke-color'],
                                width: rule[symbol]['stroke-width'],
                                lineDash: rule[symbol]['stroke-dasharray'],
                                lineJoin: rule[symbol]['stroke-linejoin'],
                                lineCap: rule[symbol]['stroke-linecap']
                            }),
                            zIndex: baseZIndex
                        }));
                        break;
                }
            });
        });
        return matchedStyles;
    },

    matchFilter: function(feature, filter) {
        var that = this;
        if(typeof filter != 'string') return true;
        try{
            return Boolean(eval(filter))
        }catch(e){
            return false;
        }
    },

    /*
     Стили мапника могут быть в двух разных форматах.

     К примеру этот стиль
     <PolygonSymbolizer>
     <CssParameter name="fill">#ededed</CssParameter>
     </PolygonSymbolizer>

     Можно записать ещё и так
     <PolygonSymbolizer fill="#ededed" />

     Нужно уметь вытащить все свойства в обоих случаях.
     Приоритет у 2-го варианта.
     */
    _getSymbolizePoperties: function(element){
        var properties = {};
        var i, attrs, l,
            child, childs = $(element).children(), childel, propname, propvalue;

        if(!element.attributes.length && !childs.length){
            return properties;
        }
        if(element.childNodes.length){
            for(child in element.childNodes){
                childel = element.childNodes[child];
                // Нам нужны только CSSPARAMETER
                if(!childel.tagName || childel.tagName != 'CSSPARAMETER') continue;
                // У элемента CssParameter обязательно должен быть аттрибут name.
                propname = childel.getAttribute('name');
                propvalue = childel.innerHTML;
                if(!propname || !propvalue) continue;

                properties[propname] = propvalue;
            }
        }

        for(i = 0, attrs = element.attributes, l = attrs.length; i < l; i++){
            properties[attrs[i].name] = attrs[i].value;
        }

        element.innerHTML = $.trim(element.innerHTML);
        if(element.innerHTML.length){
//            properties['cdata'] = element.innerHTML.substr(12, element.innerHTML.length - 18);
            properties['cdata'] = element.innerHTML.substr(1, element.innerHTML.length - 8);
        }

        return properties;
    },

    _geomTypeFromMapnik: function (geomType) {
        var _geomTypes = {
            '1': 'Point',
            '2': 'LineString',
            '3': 'Polygon',
            '4': 'GeometryCollection'
        };
        return _geomTypes[geomType] ? _geomTypes[geomType] : '';
    }

});

OLVectorLayerStyle.getRGBish = function(c, verbose){
    var i = 0, itm,
        M = c.replace(/ +/g, '').match(/(rgba?)|(\d+(\.\d+)?%?)|(\.\d+)/g);
    verbose = verbose || false;

    if(M && M.length > 3){
        while(i < 3){
            itm = M[++i];
            if(itm.indexOf('%') != -1){
                itm = Math.round(parseFloat(itm) * 2.55);
            }
            else{
                itm = parseInt(itm);
            }
            if(itm < 0 || itm > 255) return false;
            M[i] = itm;
        }
        if(c.indexOf('rgba') === 0){
            if(M[4] == undefined || M[4] < 0 || M[4] > 1) return false;
        }
        else if(M[4]) return false;
        return verbose
            ? M.slice(1)
            : M[0] + '(' + M.slice(1).join(',') + ')';
    }
    return false;
};

OLVectorLayerStyle.any2RGBA = function(color, verbose){
    var result = 'rgba({r},{g},{b},{a})';
    var namedColors = {
        'aliceblue'           : '#f0f8ff',
        'antiquewhite'        : '#faebd7',
        'aqua'                : '#00ffff',
        'aquamarine'          : '#7fffd4',
        'azure'               : '#f0ffff',
        'beige'               : '#f5f5dc',
        'bisque'              : '#ffe4c4',
        'black'               : '#000000',
        'blanchedalmond'      : '#ffebcd',
        'blue'                : '#0000ff',
        'blueviolet'          : '#8a2be2',
        'brown'               : '#a52a2a',
        'burlywood'           : '#deb887',
        'cadetblue'           : '#5f9ea0',
        'chartreuse'          : '#7fff00',
        'chocolate'           : '#d2691e',
        'coral'               : '#ff7f50',
        'cornflowerblue'      : '#6495ed',
        'cornsilk'            : '#fff8dc',
        'crimson'             : '#dc143c',
        'cyan'                : '#00ffff',
        'darkblue'            : '#00008b',
        'darkcyan'            : '#008b8b',
        'darkgoldenrod'       : '#b8860b',
        'darkgray'            : '#a9a9a9',
        'darkgreen'           : '#006400',
        'darkkhaki'           : '#bdb76b',
        'darkmagenta'         : '#8b008b',
        'darkolivegreen'      : '#556b2f',
        'darkorange'          : '#ff8c00',
        'darkorchid'          : '#9932cc',
        'darkred'             : '#8b0000',
        'darksalmon'          : '#e9967a',
        'darkseagreen'        : '#8fbc8f',
        'darkslateblue'       : '#483d8b',
        'darkslategray'       : '#2f4f4f',
        'darkturquoise'       : '#00ced1',
        'darkviolet'          : '#9400d3',
        'deeppink'            : '#ff1493',
        'deepskyblue'         : '#00bfff',
        'dimgray'             : '#696969',
        'dodgerblue'          : '#1e90ff',
        'firebrick'           : '#b22222',
        'floralwhite'         : '#fffaf0',
        'forestgreen'         : '#228b22',
        'fuchsia'             : '#ff00ff',
        'gainsboro'           : '#dcdcdc',
        'ghostwhite'          : '#f8f8ff',
        'gold'                : '#ffd700',
        'goldenrod'           : '#daa520',
        'gray'                : '#808080',
        'green'               : '#008000',
        'greenyellow'         : '#adff2f',
        'honeydew'            : '#f0fff0',
        'hotpink'             : '#ff69b4',
        'indianred'           : '#cd5c5c',
        'indigo'              : '#4b0082',
        'ivory'               : '#fffff0',
        'khaki'               : '#f0e68c',
        'lavender'            : '#e6e6fa',
        'lavenderblush'       : '#fff0f5',
        'lawngreen'           : '#7cfc00',
        'lemonchiffon'        : '#fffacd',
        'lightblue'           : '#add8e6',
        'lightcoral'          : '#f08080',
        'lightcyan'           : '#e0ffff',
        'lightgoldenrodyellow': '#fafad2',
        'lightgray'           : '#d3d3d3',
        'lightgreen'          : '#90ee90',
        'lightpink'           : '#ffb6c1',
        'lightsalmon'         : '#ffa07a',
        'lightseagreen'       : '#20b2aa',
        'lightskyblue'        : '#87cefa',
        'lightslategray'      : '#778899',
        'lightsteelblue'      : '#b0c4de',
        'lightyellow'         : '#ffffe0',
        'lime'                : '#00ff00',
        'limegreen'           : '#32cd32',
        'linen'               : '#faf0e6',
        'magenta'             : '#ff00ff',
        'maroon'              : '#800000',
        'mediumaquamarine'    : '#66cdaa',
        'mediumblue'          : '#0000cd',
        'mediumorchid'        : '#ba55d3',
        'mediumpurple'        : '#9370db',
        'mediumseagreen'      : '#3cb371',
        'mediumslateblue'     : '#7b68ee',
        'mediumspringgreen'   : '#00fa9a',
        'mediumturquoise'     : '#48d1cc',
        'mediumvioletred'     : '#c71585',
        'midnightblue'        : '#191970',
        'mintcream'           : '#f5fffa',
        'mistyrose'           : '#ffe4e1',
        'moccasin'            : '#ffe4b5',
        'navajowhite'         : '#ffdead',
        'navy'                : '#000080',
        'oldlace'             : '#fdf5e6',
        'olive'               : '#808000',
        'olivedrab'           : '#6b8e23',
        'orange'              : '#ffa500',
        'orangered'           : '#ff4500',
        'orchid'              : '#da70d6',
        'palegoldenrod'       : '#eee8aa',
        'palegreen'           : '#98fb98',
        'paleturquoise'       : '#afeeee',
        'palevioletred'       : '#db7093',
        'papayawhip'          : '#ffefd5',
        'peachpuff'           : '#ffdab9',
        'peru'                : '#cd853f',
        'pink'                : '#ffc0cb',
        'plum'                : '#dda0dd',
        'powderblue'          : '#b0e0e6',
        'purple'              : '#800080',
        'red'                 : '#ff0000',
        'rosybrown'           : '#bc8f8f',
        'royalblue'           : '#4169e1',
        'saddlebrown'         : '#8b4513',
        'salmon'              : '#fa8072',
        'sandybrown'          : '#f4a460',
        'seagreen'            : '#2e8b57',
        'seashell'            : '#fff5ee',
        'sienna'              : '#a0522d',
        'silver'              : '#c0c0c0',
        'skyblue'             : '#87ceeb',
        'slateblue'           : '#6a5acd',
        'slategray'           : '#708090',
        'snow'                : '#fffafa',
        'springgreen'         : '#00ff7f',
        'steelblue'           : '#4682b4',
        'tan'                 : '#d2b48c',
        'teal'                : '#008080',
        'thistle'             : '#d8bfd8',
        'tomato'              : '#ff6347',
        'turquoise'           : '#40e0d0',
        'violet'              : '#ee82ee',
        'wheat'               : '#f5deb3',
        'white'               : '#ffffff',
        'whitesmoke'          : '#f5f5f5',
        'yellow'              : '#ffff00',
        'yellowgreen'         : '#9acd32'
    };
    var rgba = [0, 0, 0, 1];
    var shorthandRegex, hexColor;

    color = color.toLowerCase() || '';
    verbose = verbose || false;

    color = (color in namedColors)
        ? namedColors[color]
        : color;

    if(~color.indexOf('#')){
        shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hexColor = color.replace(shorthandRegex, function(m, r, g, b){
            return r + r + g + g + b + b;
        });

        hexColor = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
        if(hexColor){
            rgba[0] = parseInt(hexColor[1].toString(), 16);
            rgba[1] = parseInt(hexColor[2].toString(), 16);
            rgba[2] = parseInt(hexColor[3].toString(), 16);
        }
    }else{
        color = OLVectorLayerStyle.getRGBish(color, true);
        if(color){
            rgba[0] = parseInt(color[0]);
            rgba[1] = parseInt(color[1]);
            rgba[2] = parseInt(color[2]);
            if(color[3]){
                rgba[3] = parseFloat(color[3]);
            }
        }
    }

    result = result
        .replace('{r}', rgba[0].toString())
        .replace('{g}', rgba[1].toString())
        .replace('{b}', rgba[2].toString())
        .replace('{a}', rgba[3].toString());

    return verbose
        ? {'str': result, 'arr': rgba}
        : result;
};

OLVectorLayerStyle.SymbolizerParsers = {
    'POLYGON'            : function(properties, opt){
        var result = {
            'fill-color': null
        };
        // Цвет в формате CSS, может быть как HEX, так и RGB/RGBA
        var fillColor = properties['fill'] || "rgba(128,128,128,1)";
        // Альтернативный способ задать прозрачность. Если цвет был в RGBA, нужно перемножить
        var fillOpacity = parseFloat(properties['fill-opacity'] || '1');

        // Проверяем и конвертируем цвет в RGBA
        var rgbaColor = OLVectorLayerStyle.any2RGBA(fillColor, true);

        // Перемножаем заданный opacity
        rgbaColor.arr[3] *= fillOpacity;

        result['fill-color'] = 'rgba(' + rgbaColor.arr.join(',') + ')';
        return result;
    },
    'POLYGONPATTERN'     : function(properties, opt){},
    'LINE'               : function(properties, opt){
        var result = {
            'stroke-color'    : null,
            'stroke-width'    : null,
            'stroke-linejoin' : null,
            'stroke-linecap'  : null,
            'stroke-dasharray': null
        };

        // Прозрачность контура
        var strokeOpacity = parseFloat(properties['stroke-opacity'] || '1');

        // Цвет контура
        result['stroke-color'] = properties['stroke'] || 'rgba(0,0,0,1)';
        result['stroke-color'] = OLVectorLayerStyle.any2RGBA(result['stroke-color'], true);
        result['stroke-color'].arr[3] *= strokeOpacity;
        result['stroke-color'] = 'rgba(' + result['stroke-color'].arr.join(',') + ')';

        // Толщина контура
        result['stroke-width'] = parseFloat(properties['stroke-width'] || '1');

        // Форма соединения контура на углах
        result['stroke-linejoin'] = ~$.inArray(properties['stroke-linejoin'], ['miter', 'round', 'bevel'])
            ? properties['stroke-linejoin']
            : 'miter';

        // Форма границ контура
        result['stroke-linecap'] = ~$.inArray(properties['stroke-linecap'], ['butt', 'round', 'square'])
            ? properties['stroke-linejoin']
            : 'butt';

        if(properties['stroke-dasharray'] !== undefined && properties['stroke-dasharray'].length){
            properties['stroke-dasharray'] = properties['stroke-dasharray'].split(',');
            if(properties['stroke-dasharray'].length > 1){
                result['stroke-dasharray'] = properties['stroke-dasharray'];
            }
        } else {
            result['stroke-dasharray'] = undefined;
        }

        return result;
    },
    'LINEPATTERN'        : function(properties, opt){},
    'POINT'              : function(properties, opt){
        var result = {
            'file'            : null,
            'fill-color'      : null,
            'opacity'         : 1,
            'transform'       : null, // Трансформация SVG http://www.w3.org/TR/SVG/coords.html#TransformAttribute
            'stroke-color'    : null,
            'stroke-width'    : null,
            'scale'           : 1,
            'radius'          : 5
        };

        // Прозрачность контура
        var strokeOpacity = parseFloat(properties['stroke-opacity'] || '1');
        // Цвет в формате CSS, может быть как HEX, так и RGB/RGBA
        var fillColor = properties['fill'] || "rgba(0,0,255,1)";
        // Альтернативный способ задать прозрачность. Если цвет был в RGBA, нужно перемножить
        var fillOpacity = parseFloat(properties['fill-opacity'] || '1');

        // transform
        var markerScale;
        var markerRotate;

        // Проверяем и конвертируем цвет в RGBA
        var rgbaColor = OLVectorLayerStyle.any2RGBA(fillColor, true);

        // Перемножаем заданный opacity
        rgbaColor.arr[3] *= fillOpacity;

        result['fill-color'] = 'rgba(' + rgbaColor.arr.join(',') + ')';

        // Цвет контура
        result['stroke-color'] = properties['stroke'] || 'rgba(0,0,0,1)';
        result['stroke-color'] = OLVectorLayerStyle.any2RGBA(result['stroke-color'], true);
        result['stroke-color'].arr[3] *= strokeOpacity;
        result['stroke-color'] = 'rgba(' + result['stroke-color'].arr.join(',') + ')';

        // Толщина контура
        result['stroke-width'] = parseFloat(properties['stroke-width'] || '0.5');

        result['file'] = properties['file'] || null;
        if(result['file'] && opt.markerImgUrl){
            if (result['file'].substring(0, 4) === 'img/') {
                result['file'] = result['file'].replace(/^img\//, opt.markerImgUrl);
            }
        }
        result['opacity'] = parseFloat(properties['opacity'] || 1);
        result['transform'] = properties['transform'] || null;
        if (result['transform'] !== null) {
            markerScale = result['transform'].match( /scale\(\s*([0-9.]+)\s*\)/i );
            if (markerScale && markerScale[1] !== undefined) {
                result['scale'] = parseFloat(markerScale[1]);
            }
            markerRotate = result['transform'].match( /rotate\(\s*([0-9.]+)\s*\)/i );
            if (markerRotate && markerRotate[1] !== undefined) {
                result['rotation'] = parseFloat(markerRotate[1]) * Math.PI / 180;
            }
        }
        result['radius'] = parseFloat(properties['width'] || 10) / 2;

        return result;
    },
    'MARKERS'            : function(properties, opt){
        var result = {
            'file'            : null,
            'fill-color'      : null,
            'opacity'         : 1,
            'transform'       : null, // Трансформация SVG http://www.w3.org/TR/SVG/coords.html#TransformAttribute
            'stroke-color'    : null,
            'stroke-width'    : null,
            'scale'           : 1,
            'radius'          : 5
        };

        // Прозрачность контура
        var strokeOpacity = parseFloat(properties['stroke-opacity'] || '1');
        // Цвет в формате CSS, может быть как HEX, так и RGB/RGBA
        var fillColor = properties['fill'] || "rgba(0,0,255,1)";
        // Альтернативный способ задать прозрачность. Если цвет был в RGBA, нужно перемножить
        var fillOpacity = parseFloat(properties['fill-opacity'] || '1');

        // transform
        var markerScale;
        var markerRotate;

        // Проверяем и конвертируем цвет в RGBA
        var rgbaColor = OLVectorLayerStyle.any2RGBA(fillColor, true);

        // Перемножаем заданный opacity
        rgbaColor.arr[3] *= fillOpacity;

        result['fill-color'] = 'rgba(' + rgbaColor.arr.join(',') + ')';

        // Цвет контура
        result['stroke-color'] = properties['stroke'] || 'rgba(0,0,0,1)';
        result['stroke-color'] = OLVectorLayerStyle.any2RGBA(result['stroke-color'], true);
        result['stroke-color'].arr[3] *= strokeOpacity;
        result['stroke-color'] = 'rgba(' + result['stroke-color'].arr.join(',') + ')';

        // Толщина контура
        result['stroke-width'] = parseFloat(properties['stroke-width'] || '0.5');

        result['file'] = properties['file'] || null;
        if(result['file'] && opt.markerImgUrl){
            if (result['file'].substring(0, 4) === 'img/') {
                result['file'] = result['file'].replace(/^img\//, opt.markerImgUrl);
            }
        }
        result['opacity'] = parseFloat(properties['opacity'] || 1);
        result['transform'] = properties['transform'] || null;
        if (result['transform'] !== null) {
            markerScale = result['transform'].match( /scale\(\s*([0-9.]+)\s*\)/i );
            if (markerScale && markerScale[1] !== undefined) {
                result['scale'] = parseFloat(markerScale[1]);
            }
            markerRotate = result['transform'].match( /rotate\(\s*([0-9.]+)\s*\)/i );
            if (markerRotate && markerRotate[1] !== undefined) {
                result['rotation'] = parseFloat(markerRotate[1]) * Math.PI / 180;
            }
        }
        result['radius'] = parseFloat(properties['width'] || 10) / 2;

        return result;
    },
    'GLYPH'              : function(properties, opt){},
    'TEXT'               : function(properties, opt){
        var result = {
            'face-name'        : 'Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, Sans-serif',
            'fill'             : 'rgba(0,0,0,1)',
            'halo-fill'        : 'rgba(255,255,255,1)',
            'halo-radius'      : 0,
            'size'             : 10,
            'dx'               : 0, // Смещение относительно точки
            'dy'               : 0, // Смещение относительно точки
            'base-line'        : 'middle',
            'text-align'       : null,
            'allow-overlap'    : true,
            'cdata'            : null

        };

        result['cdata'] = properties['cdata'] || null;
        // TODO: Разрулить ещё и font weight и прочие параметры, когда будут нужны
        // result['face-name'] = properties['face-name'] || result['face-name'];
        result['base-line'] = properties['vertical-align'] || 'auto';

        result['text-align'] = ~$.inArray(properties['justify-alignment'], ['left', 'right', 'center'])
            ? properties['justify-alignment']
            : 'start';

        result['fill'] = properties['fill'] || result['fill'];
        result['fill'] = OLVectorLayerStyle.any2RGBA(result['fill'], true);
        result['fill'] = 'rgba(' + result['fill'].arr.join(',') + ')';
        result['halo-fill'] = properties['halo-fill'] || result['halo-fill'];
        result['halo-fill'] = OLVectorLayerStyle.any2RGBA(result['halo-fill'], true);
        result['halo-fill'] = 'rgba(' + result['halo-fill'].arr.join(',') + ')';

        result['halo-radius'] = parseFloat(properties['halo-radius'] || 0);
        result['size'] = parseFloat(properties['size'] || 10);
        result['dx'] = parseFloat(properties['dx'] || 0);
        result['dy'] = parseFloat(properties['dy'] || 0);

        if(result['base-line'] == 'auto'){
            result['base-line'] =
                result['dy'] < 0 ? 'bottom' :
                    result['dy'] == 0 ? 'middle' :
                        'top';
        }

        if(result['text-align'] == 'start'){
            result['text-align'] =
                result['dx'] < 0 ? 'right' :
                    result['dx'] == 0 ? 'center' :
                        'left';
        }

        result['allow-overlap'] = properties['allow-overlap'] !== undefined
            ? properties['allow-overlap'] == 'true'
            : true;

        if (result['base-line'] == 'bottom') {
            result['dy'] -= result['size'] / 2;
            result['base-line'] = 'middle';
        }
        if (result['base-line'] == 'top') {
            result['dy'] += result['size'] / 2;
            result['base-line'] = 'middle';
        }

        // глобальное разрешение расчтеа перекрытий текстов, только если задано
        if (properties['allow-overlap'] !== undefined && !result['allow-overlap']) {
            ol.OMS_VECTOR_ALLOW_OVERLAP = true;
        }

        return result;
    },
    'RASTER'             : function(properties, opt){},
    'SHIELD'             : function(properties, opt){},
    'BUILDING'           : function(properties, opt){},
    'MINSCALEDENOMINATOR': null,
    'MAXSCALEDENOMINATOR': null,
    'FILTER'             : function(filter){
        var i;
        var logical_operators = {
            'and': '&&',
            'or' : '||',
            'not': '!'
        };

        var logical_operator = '';

        var comparison_operators = {
            '='    : '==',
            '!='   : '!=',
            '&gt;' : '>',
            '&lt;' : '<',
            '&gt;=': '>=',
            '&lt;=': '<='
        };

        var comparison_operator = '';

        var arithmetic_operators = '*/+-%';
        var arithmetic_operator = '';

        var regexp_match = '';

        var buffer = "";

        var bracket_on = false;
        var varb_on = false;
        var valb_on = false;

        var ch;
        var variable = '';
        var val = '';

        var expecting_comparison_operator = false;
        var expecting_arithmetic_operator = false;
        var expecting_value = false;
        var expecting_regexp = false;

        var escape = false;
        filter = filter.replace(new RegExp('\\[mapnik::geometry_type\\] = (\\d)'), "[mapnik::geometry_type] = '\$1'");
        filter += ' ';

        for(i in filter){
            ch = filter.charAt(i);

            switch(ch){
                case "(":
                    if(!varb_on && !valb_on && !expecting_regexp){
                        buffer += ch + ' ';
                        bracket_on = true;
                        continue;
                    }
                    break;
                case ')':
                    if(!varb_on && !valb_on && bracket_on && !expecting_regexp){
                        buffer += ch + ' ';
                        continue;
                    }
                    break;
                case '[':
                    if(!varb_on && !valb_on && !expecting_regexp){
                        variable = '';
                        varb_on = true;
                        continue;
                    }
                    break;
                case ']':
                    if(varb_on && !valb_on && !expecting_regexp){
                        varb_on = false;
                        variable = "feature.get('" + variable.replace(/::/g, "').get('") + "')";
                        buffer += variable;
                        expecting_comparison_operator = true;
                        expecting_arithmetic_operator = true;
                        expecting_regexp = true;
                        continue;
                    }
                    break;
                case "'":
                    if(expecting_value && !escape){
                        valb_on = !valb_on;
                        if(!valb_on){
                            expecting_value = false;
                            buffer += (val == 'true' || val == 'false') ? val + ' ' : "'" + val + "' ";
                            val = "";
                        }
                        continue;
                    }
                    break;
            }

            // Пишем название переменной
            if(varb_on){
                variable += ch;
                continue;
            }

            // если не ожидаем ничего иного, то должен быть логический оператор
            if(
                !varb_on && !valb_on && !expecting_value && !expecting_comparison_operator && !expecting_arithmetic_operator &&
                ch != ' '
            ){
                logical_operator = filter.substr(i, 3);
                if(logical_operator in logical_operators){
                    buffer += logical_operators[logical_operator];
                    if(logical_operators[logical_operator] !== '!'){
                        buffer += ' ';
                    }
                    continue;
                }

                logical_operator = logical_operator.substr(0, 2);
                if(logical_operator in logical_operators){
                    buffer += logical_operators[logical_operator] + ' ';
                    continue;
                }
            }

            if(expecting_comparison_operator && expecting_arithmetic_operator && expecting_regexp && ch != ' '){
                if(~arithmetic_operators.indexOf(ch)){
                    expecting_comparison_operator = expecting_regexp = false;
                }else if(ch == '=' || ch == '&' || ch == '!'){
                    expecting_arithmetic_operator = expecting_regexp = false;
                }else if(ch == '.'){
                    expecting_comparison_operator = expecting_arithmetic_operator = false;
                }
            }

            // Ожидаем регулярное выражение
            if(expecting_regexp){
                if(!regexp_match.length && ch == ' ') continue;
                regexp_match += ch;
                if(ch == ')' && filter.charAt(parseInt(i) - 1) == "'" && filter.charAt(parseInt(i) - 2) !== '\\'){
                    regexp_match = regexp_match.replace("match('", 'match(/');
                    regexp_match = regexp_match.substr(0, regexp_match.length - 2) + '/)';
                    buffer += regexp_match + ' ';
                    expecting_regexp = false;
                    regexp_match = '';
                    continue;
                }
            }

            // Ожидаем арифметический оператор
            if(expecting_arithmetic_operator && ch != ' '){
                arithmetic_operator += ch;
                if(arithmetic_operator.length > 1 && !(/[\d\.]/.test(ch))){
                    buffer += arithmetic_operator.substr(0, arithmetic_operator.length - 1) + ' ';
                    expecting_arithmetic_operator = false;
                    expecting_comparison_operator = true;
                    arithmetic_operator = '';
                }else{
                    continue;
                }
            }

            // Ожидаем оператор сравнения, игнорируем пробелы
            if(expecting_comparison_operator && ch != ' '){
                comparison_operator += ch;
                if(comparison_operator in comparison_operators){
                    if(comparison_operator.length == 4 && filter.charAt(parseInt(i) + 1) == '='){
                        comparison_operator += filter.charAt(parseInt(i) + 1);
                    }
                    buffer += ' ' + comparison_operators[comparison_operator] + ' ';
                    comparison_operator = '';
                    expecting_comparison_operator = false;
                    expecting_value = true;
                }
                continue;
            }

            // Ожидаем значение
            if(valb_on){
                escape = false;
                val += ch;
                if(ch == '\\'){
                    escape = true;
                }
            }else if(expecting_value){
                if(/[\d\.]/.test(ch)){
                    val += ch;
                }else if(val.length > 0 && !/[\d\.]/.test(ch)){
                    buffer += val + ' ';
                    val = '';
                    expecting_value = false;
                }
            }
        }
        buffer = buffer.replace(".get('mapnik')", '.getGeometry()').replace(".get('geometry_type')", '.getType()');
        buffer = buffer.replace(new RegExp('\\.getGeometry\\(\\)\\.getType\\(\\) == \'(\\d)\''), ".getGeometry().getType().replace('Multi', '') == that._geomTypeFromMapnik('\$1')");
        return buffer;
    }
};

OLVectorLayerStyle.getObjectsFields = function (mapnikStyleXML) {
    var fields = mapnikStyleXML.match(/\[[a-z0-9_]+\]/g) || [];
    return fields.map(function (f) {
        return f.slice(1, -1);
    });
}

// 100 млн - множитель (коэффициент) для сортировки слоев.
// Т.к. точечные объекты внутри слоя будут основывать свой ZIndex
// на освновании Y координаты (примерно от -20 млн до 20 млн)
// а ещё нужно учесть дополнительные махинации с текстовыми подписями
// то все смещения внутри одного слоя не должны вылезать за межслойные пределы сортировки
OLVectorLayerStyle.baseZIndexMultiplier = 100000000,

module.exports = OLVectorLayerStyle;



//////////////////
// WEBPACK FOOTER
// ./src/~/OLVectorLayerStyle.js
// module id = 48
// module chunks = 0